// Platform-aware Alert implementation
import { Alert as RNAlert, Platform } from 'react-native';
import type { AlertButton, AlertOptions } from './AlertTypes';

// Web-specific Alert class
class WebAlert {
  private static showCallback: ((
    title: string,
    message?: string,
    buttons?: AlertButton[],
    options?: AlertOptions
  ) => void) | null = null;

  static setShowCallback(callback: typeof WebAlert.showCallback) {
    WebAlert.showCallback = callback;
  }

  static alert(
    title: string,
    message?: string,
    buttons?: AlertButton[],
    options?: AlertOptions
  ): void {
    if (!WebAlert.showCallback) {
      console.warn('Alert: Provider not initialized. Using fallback.');
      // Fallback to browser alert
      const msg = message ? `${title}\n\n${message}` : title;
      if (typeof window !== 'undefined') {
        window.alert(msg);
      }
      return;
    }

    // Normalize buttons - if no buttons provided, use default OK button
    const normalizedButtons = buttons && buttons.length > 0
      ? buttons
      : [{ text: 'OK', style: 'default' as const }];

    WebAlert.showCallback(title, message, normalizedButtons, options);
  }
}

// Export the appropriate Alert based on platform
const Alert = Platform.OS === 'web' ? WebAlert : RNAlert;

export default Alert;
